import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Shared parts of RegisterSlice — plan §5.2. Mobile is a strict SUBSET: 8 identical state
 * fields with identical defaults and 10 identical reducers, 0 divergent. Web adds one state
 * field (`drk`), 3 reducers, and the logout `extraReducers`.
 *
 * ⚠️ `action` must be `PayloadAction<any>`, never `any` — see the ledger.
 *
 * Two things preserved verbatim because they are what the apps do, not because they are good:
 * - `getUsersListSuccess` / `getRegistrationData` use the COMMA OPERATOR to sequence two
 *   assignments (`state.a = x, state.b = y`). Same effect as two statements; left alone.
 * - `changePinRequestResponse` logs the whole action on every call.
 */
export interface SharedRegisterState {
    users: {
        [key: string]: any
      },
      deviceRegistrationResponse :  {
        [key: string]: any
      },
   isRegisterDataFetching : boolean,
   requestKeyResponse :[],
   isChangePinInProgress: boolean,
   isChangePinInDone: boolean,
   isRegisterFCMDone: boolean
   isChangePinFailed: boolean
  }

export const sharedInitialState: SharedRegisterState = {
    users: {},
    deviceRegistrationResponse : {},
    isRegisterDataFetching : false,
    requestKeyResponse : [],
    isChangePinInProgress: false,
    isChangePinInDone: false,
    isRegisterFCMDone: false,
    isChangePinFailed: false
  };

/** Identical in both apps — every mobile reducer is here. */
export const sharedReducers = {
      getUsersList : (state: SharedRegisterState, action: PayloadAction<any>) =>{
        state.isRegisterDataFetching = true;
      },
      getUsersListSuccess : (state: SharedRegisterState, action: PayloadAction<any>) =>{
        state.users = action.payload,
        state.isRegisterDataFetching = false
      },
      requestRegistrationResponse : (state: SharedRegisterState, action: PayloadAction<any>) => {
        state.isRegisterDataFetching = true
      },
      getRegistrationData : (state: SharedRegisterState, action: PayloadAction<any>) => {
        state.deviceRegistrationResponse = action.payload,
        state.isRegisterDataFetching = false
      },
      requestRegistrationKey : (state: SharedRegisterState, action: PayloadAction<any>) =>{
        state.isRegisterDataFetching = true
      },
      requestRegistrationKeyResponse : (state: SharedRegisterState, action: PayloadAction<any>) => {
        state.requestKeyResponse = action.payload
        state.isRegisterDataFetching = false
      },
      changePinRequest: (state: SharedRegisterState, action: PayloadAction<any>) => {
        state.isChangePinInProgress = true;
      },
      changePinRequestResponse: (state: SharedRegisterState, action: PayloadAction<any>) => {
        console.log("action: ", action);
        if ( action.payload?.code ){
          state.isChangePinFailed = true;
        }
        state.isChangePinInProgress = false;
        state.isChangePinInDone = true;
      },
      resetChangePinFlag: (state: SharedRegisterState) => {
        state.isChangePinInDone = false;
        state.isChangePinFailed = false;
      },
      registerFCMToken: (state: SharedRegisterState, action: PayloadAction<any>) => {
        state.isRegisterFCMDone = true;
      },
};
